import { UPDATE_JOB_STATUS } from '../../endpoints';
import makeAuthenticatedRequest from '../base-api';

interface UpdateCandidateStatusParams {
  application_id?: string;
  email: string;
  status?: string;
  score?: number;
  screeningStatus?: string;
}

interface UpdateCandidateStatusResponse {
  success: boolean;
  message?: string;
}

const updateCandidateStatusApi = async (
  data: UpdateCandidateStatusParams
): Promise<UpdateCandidateStatusResponse> => {
  try {
    const response = await makeAuthenticatedRequest(UPDATE_JOB_STATUS, {
      method: 'PATCH',
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json',
      },
    });

    const result = await response.json();

    if (!response.ok) {
      if (!result.success) {
        throw new Error(result.message);
      } else {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
    }

    return result;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export { updateCandidateStatusApi, type UpdateCandidateStatusResponse };
